// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__9v9E5","innerBox":"Signup_innerBox__Idmcv","footer":"Signup_footer__961uH","error":"Signup_error__DKwF5"};